module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/072-87ed089ceca82fd7c1694a5578aa417b.jpg";